import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { isDisclosure, formatAsGermanDate } from '~/functions/helpers';
export default defineComponent({
  props: {
    questionnaireAssignment: {
      type: Object,
      required: true
    },
    questionnaireTemplate: {
      type: Object,
      required: true
    }
  },
  setup: function setup(props) {
    var userInputMapping = computed(function () {
      if (!props.questionnaireAssignment) return {};
      return Object.assign.apply(Object, [{}].concat(_toConsumableArray(props.questionnaireAssignment.userInputs.map(function (x) {
        return _defineProperty({}, x.question.id, x);
      }))));
    });
    var questionnaireResultMapping = computed(function () {
      // TODO REMOVE THIS
      if (!props.questionnaireAssignment) return {};
      return Object.assign.apply(Object, [{}].concat(_toConsumableArray(props.questionnaireAssignment.questionnaireResults.map(function (x) {
        return _defineProperty({}, x.sectionLabel, x);
      }))));
    });
    var updatedAt = computed(function () {
      var asGermanDate = formatAsGermanDate(props.questionnaireAssignment.updatedAt);
      return asGermanDate !== null && asGermanDate !== void 0 ? asGermanDate : 'N/A';
    });
    return {
      userInputMapping: userInputMapping,
      questionnaireResultMapping: questionnaireResultMapping,
      updatedAt: updatedAt
    };
  },
  data: function data() {
    return {
      showDetailedScoringAndQuestionnaire: true
    };
  },
  computed: {
    esgSections: function esgSections() {
      var _this = this;
      return this.questionnaireTemplate.sections.filter(function (e) {
        return !isDisclosure(e.id);
      }).map(function (e) {
        return _objectSpread(_objectSpread({}, e), {}, {
          result: _this.questionnaireResultMapping[e.label],
          sections: e.sections.map(function (sec) {
            return _objectSpread(_objectSpread({}, sec), {}, {
              result: _this.questionnaireResultMapping[sec.label]
            });
          })
        });
      });
    },
    disclosureSection: function disclosureSection() {
      var section = this.questionnaireTemplate.sections.find(function (e) {
        return isDisclosure(e.id);
      });
      return section;
    }
  }
});